import { z } from 'zod';

const IAlternativeUploadSchema = z.object({
  fileType: z.string().min(1),
  fileId: z.string().min(1),
  fileUrl: z.string().min(1),
});

export const QuotesSchema = z.object({
  reference: z.string(),
  description: z.string().min(1),
  attachment: z.array(IAlternativeUploadSchema).optional(),
});
